import { render } from "./AdvertiserVisitorsBreakdownWidget.vue?vue&type=template&id=5850dfb3"
import script from "./AdvertiserVisitorsBreakdownWidget.vue?vue&type=script&lang=js"
export * from "./AdvertiserVisitorsBreakdownWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__